import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function ArrowLeftIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M29.3137 14.1397L29.3605 14.15H9.28586L15.5966 7.80446C15.9056 7.49466 16.0751 7.07499 16.0751 6.63452C16.0751 6.19404 15.9056 5.77731 15.5966 5.46677L14.6146 4.48109C14.3059 4.17129 13.8944 4 13.4556 4C13.0166 4 12.6049 4.17007 12.2961 4.47987L1.4783 15.3324C1.1683 15.6434 0.998787 16.0577 1.00001 16.4984C0.998787 16.9416 1.1683 17.3561 1.4783 17.6666L12.2961 28.5201C12.6049 28.8297 13.0163 29 13.4556 29C13.8944 29 14.3059 28.8294 14.6146 28.5201L15.5966 27.5345C15.9056 27.2251 16.0751 26.8121 16.0751 26.3716C16.0751 25.9314 15.9056 25.5401 15.5966 25.2305L9.21464 18.8496H29.3361C30.2402 18.8496 31 18.0677 31 17.1611V15.767C31 14.8603 30.2178 14.1397 29.3137 14.1397Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
